<template>
  <AppLayout>
    <div class="col-12 layout-spacing">
      <div class="widget widget-six">
        <IndexHeader />

        <div class="widget-heading">
          <div class="row">
            <div class="col-12 d-flex align-items-center">
              <h4 class="me-3 my-0">Producenci</h4>

              <button
                @click="addProducent"
                class="btn btn-primary btn-sm"
              >
                <i class="bi bi-plus-circle me-2"></i>
                Dodaj producenta
              </button>

              <Link
                class="btn btn-outline-primary btn-sm ms-3"
                :href="route('articles.index')"
              >
                Lista artykułów
              </Link>
            </div>
          </div>
        </div>

        <div class="widget-content">

          <!-- FILTRY -->
          <div class="row mb-3">
            <div class="col-md-4">
              <div class="input-group">
                <span class="input-group-text">
                  <i class="bi bi-search"></i>
                </span>

                <input
                  v-model="search"
                  type="text"
                  class="form-control"
                  placeholder="Szukaj producenta..."
                >
              </div>
            </div>

            <div class="col-md-2">
              <select
                v-model="perPage"
                class="form-select"
              >
                <option :value="10">10</option>
                <option :value="25">25</option>
                <option :value="50">50</option>
                <option :value="100">100</option>
              </select>
            </div>
          </div>

          <!-- TABELA -->
          <div class="custom-table">
            <div class="table-responsive">

              <table class="table table-hover align-middle">
                <thead>
                <tr>
                  <th width="60">#</th>
                  <th>Nazwa producenta</th>
                  <th width="220">Akcje</th>
                </tr>
                </thead>

                <tbody>

                <tr
                  v-for="(producent, index) in paginatedProducers"
                  :key="producent.id"
                >
                  <td>
                    {{ ((currentPage - 1) * perPage) + index + 1 }}
                  </td>

                  <td>
                    <input
                      v-if="editingId === producent.id"
                      v-model="producent.name"
                      class="form-control"
                    >

                    <span v-else>
                      {{ producent.name }}
                    </span>
                  </td>

                  <td>
                    <button
                      v-if="editingId === producent.id"
                      @click="updateProducent(producent)"
                      class="btn btn-success btn-sm me-2"
                    >
                      <i class="bi bi-check-lg me-1"></i>
                      Zapisz
                    </button>

                    <button
                      v-else
                      @click="editProducent(producent)"
                      class="btn btn-outline-info btn-sm me-2"
                    >
                      <i class="bi bi-pencil me-1"></i>
                      Edytuj
                    </button>

                    <button
                      @click="deleteProducent(producent)"
                      class="btn btn-danger btn-sm"
                    >
                      <i class="bi bi-trash me-1"></i>
                      Usuń
                    </button>
                  </td>
                </tr>

                <tr v-if="addingNew">
                  <td>Nowy</td>

                  <td>
                    <input
                      v-model="newProducent.name"
                      class="form-control"
                    >
                  </td>

                  <td>
                    <button
                      @click="saveNewProducent"
                      class="btn btn-success btn-sm me-2"
                    >
                      <i class="bi bi-save me-1"></i>
                      Zapisz
                    </button>

                    <button
                      @click="cancelNewProducent"
                      class="btn btn-danger btn-sm"
                    >
                      <i class="bi bi-x-circle me-1"></i>
                      Anuluj
                    </button>
                  </td>
                </tr>

                <tr v-if="filteredProducers.length === 0">
                  <td colspan="3" class="text-center text-muted py-4">
                    Nie znaleziono producentów
                  </td>
                </tr>

                </tbody>
              </table>

<div
    class="d-flex justify-content-between align-items-center mt-3"
    v-if="filteredProducers.length"
>
    <div class="d-flex align-items-center">

        <small class="text-muted me-3">
            Wyświetlono
            {{ ((currentPage - 1) * perPage) + 1 }}
            -
            {{
                Math.min(
                    currentPage * perPage,
                    filteredProducers.length
                )
            }}
            z {{ filteredProducers.length }}
        </small>

    </div>

    <nav v-if="totalPages > 1">
        <ul class="pagination pagination-sm mb-0">

            <!-- pierwsza -->
            <li
                class="page-item"
                :class="{ disabled: currentPage === 1 }"
            >
                <a
                    href="#"
                    class="page-link"
                    @click.prevent="currentPage = 1"
                >
                    «
                </a>
            </li>

            <!-- poprzednia -->
            <li
                class="page-item"
                :class="{ disabled: currentPage === 1 }"
            >
                <a
                    href="#"
                    class="page-link"
                    @click.prevent="currentPage--"
                >
                    ‹
                </a>
            </li>

            <!-- strony -->
            <li
                v-for="page in visiblePages"
                :key="page"
                class="page-item"
                :class="{ active: page === currentPage }"
            >
                <a
                    href="#"
                    class="page-link"
                    @click.prevent="currentPage = page"
                >
                    {{ page }}
                </a>
            </li>

            <!-- następna -->
            <li
                class="page-item"
                :class="{ disabled: currentPage === totalPages }"
            >
                <a
                    href="#"
                    class="page-link"
                    @click.prevent="currentPage++"
                >
                    ›
                </a>
            </li>

            <!-- ostatnia -->
            <li
                class="page-item"
                :class="{ disabled: currentPage === totalPages }"
            >
                <a
                    href="#"
                    class="page-link"
                    @click.prevent="currentPage = totalPages"
                >
                    »
                </a>
            </li>

        </ul>
    </nav>
</div>

            </div>
          </div>

        </div>
      </div>
    </div>
  </AppLayout>
</template>

<script>
import AppLayout from "@/Layouts/App.vue";
import {usePermission} from "@/composables/resources/js/composables/permissions.js";
import IndexHeader from "@/Pages/Warehouses/Articles/IndexHeader.vue";

const {hasPermission} = usePermission();

export default {
  components: {AppLayout, IndexHeader},
  props: {
    producers: Array
  },
  data() {
    return {
      hasPermission,
      editingId: null,
      addingNew: false,
      newProducent: this.getEmptyForm(),
	   search: '',
      currentPage: 1,
      perPage: 10
    };
  },
    computed: {
	visiblePages() {
    let start = Math.max(1, this.currentPage - 2);
    let end = Math.min(this.totalPages, this.currentPage + 2);

    return Array.from(
        { length: end - start + 1 },
        (_, i) => start + i
    );
},

    filteredProducers() {
      if (!this.search) {
        return this.producers;
      }

      return this.producers.filter(item =>
        item.name.toLowerCase().includes(this.search.toLowerCase())
      );
    },

    paginatedProducers() {
      const start = (this.currentPage - 1) * this.perPage;
      const end = start + this.perPage;

      return this.filteredProducers.slice(start, end);
    },

    totalPages() {
      return Math.ceil(this.filteredProducers.length / this.perPage);
    }
  },

  watch: {
    search() {
      this.currentPage = 1;
    }
  },

  methods: {
    getEmptyForm() {
      return {
        id: null,
        name: '',
      };
    },
    addProducent() {
      this.addingNew = true;
      this.newProducent = this.getEmptyForm();
    },
    cancelNewProducent() {
      this.addingNew = false;
      this.newProducent = this.getEmptyForm();
    },
	editProducent(producer) {
	  if (producer.is_used) {
		Toast.fire({
		  icon: 'warning',
		  title: 'Producent jest używany',
		  html: 'Ten producent jest już przypisany do artykułów. Czy na pewno chcesz go edytować?',
		  showConfirmButton: true,
		  showCancelButton: true,
		  confirmButtonText: 'Tak, edytuj',
		  cancelButtonText: 'Anuluj'
		}).then((result) => {
		  if (result.isConfirmed) {
			this.editingId = producer.id;
		  }
		});
		return;
	  }

	  this.editingId = producer.id;
	},

    updateProducent(producent) {
      this.$inertia.put(route('producents.update', producent.id), producent, {
        onSuccess: () => {
          this.editingId = null;
        }
      });
    },
    saveNewProducent() {
      this.$inertia.post(route('producents.store'), this.newProducent, {
        onSuccess: () => {
          this.addingNew = false;
          this.newProducent = this.getEmptyForm();
        }
      });
    },
	deleteProducent(producer) {
	  if (producer.is_used) {
		Toast.fire({
		  icon: 'error',
		  title: 'Nie można usunąć producenta',
		  html: 'Ten producent jest przypisany do artykułów i nie może zostać usunięty.',
		  confirmButtonText: 'OK'
		});
		return;
	  }

	  Toast.fire({
		toast: false,
		icon: 'warning',
		title: 'Usuwanie producenta',
		html: 'Czy na pewno chcesz usunąć wybranego producenta?',
		showDenyButton: true,
		showConfirmButton: true,
		confirmButtonText: 'Tak',
		denyButtonText: 'Nie',
		timer: false,
		position: 'center'
	  }).then((result) => {
		if (result.isConfirmed) {
		  this.$inertia.delete(route('producents.destroy', producer.id));
		}
	  });
	}
  }
};
</script>
